import DiagnosticsScreen from 'features/diagnostics';

export default function DiagnosticsPage() {
  return <DiagnosticsScreen />;
}
